/**
 * Extracts plain text from HTML content for display previews
 * @param html HTML string that may contain formatting tags
 * @returns Plain text without HTML tags
 */
export const stripHtmlTags = (html: string): string => {
  if (!html) return '';

  // If it's already plain text, return as-is
  if (!html.includes('<')) {
    return html;
  }

  // Use DOMParser instead of innerHTML for safer HTML parsing
  // This prevents script execution from malicious HTML payloads
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  return doc.body.textContent || '';
};

/**
 * Creates a preview text from HTML content with a character limit
 * @param html HTML string that may contain formatting tags
 * @param maxLength Maximum number of characters for the preview
 * @returns Truncated plain text preview
 */
export const createTextPreview = (html: string, maxLength = 50): string => {
  const plainText = stripHtmlTags(html);
  if (plainText.length <= maxLength) {
    return plainText;
  }
  return plainText.substring(0, maxLength) + '...';
};